import CircularProgress, {
    circularProgressClasses,
} from '@mui/material/CircularProgress';

const ProgressWait = (props) => {

    return (
        <div className="m-auto">
            <CircularProgress
                variant="indeterminate"
                disableShrink
                sx={{
                    color: "var(--square-ink)",
                    animationDuration: '550ms',
                    position: 'relative',
                    left: 0,
                    [`& .${circularProgressClasses.circle}`]: {
                        strokeLinecap: 'round',
                    },
                }}
                size={40}
                thickness={4}
                {...props}
            />
        </div>
    );
}

export default ProgressWait;